export default __webpack_public_path__ + "static/media/CheckOutlineWhite.bb844cd3.svg";